export const ANALYTICS_CHANNEL = 'postOffice';
